var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"label":"","color":_vm.getColorCreationDate()}},[_vm._v(" "+_vm._s(_vm._f("formatDate2")(_vm.date))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }